<script lang="ts">
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import type { ClassValue } from 'svelte/elements';

  interface Props {
    size?: ClassValue;
    children?: import('svelte').Snippet;
  }

  let { size = 'w-fit max-w-xl', children }: Props = $props();

  let position = $state([0, 0]);
  let elemSize = [1, 1];

  let elem: HTMLDivElement;

  onMount(() => {
    const handler = () => (elemSize = [elem.clientWidth, elem.clientHeight]);

    handler();
    const observer = new ResizeObserver(handler);

    observer.observe(elem);
    return () => observer.disconnect();
  });

  const margin = 20;
  const mouseMove = (e: MouseEvent) => {
    let nextY = e.clientY + margin;

    if (nextY + elemSize[1] > window.innerHeight) nextY -= 2 * margin + elemSize[1];

    position = [
      Math.max(elemSize[0] / 2, Math.min(window.innerWidth - elemSize[0] / 2, e.clientX)),
      nextY,
    ];
  };
</script>

<div
  bind:this={elem}
  class={['card bg-base-300 fixed top-0 left-0 block p-4 whitespace-normal shadow-lg', size]}
  style:transform="translate({position[0]}px, {position[1]}px) translate(-50%, 0)"
  in:fade|global={{
    delay: 500,
  }}
>
  {@render children?.()}
</div>

<svelte:window onmousemove={mouseMove} />
